import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-edit\">\r\n  <defs>\r\n    <style>\r\n      #icon-edit .cls-1 {\r\n        fill: #40a9ff;\r\n      }\r\n\r\n      #icon-edit .cls-2 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <rect id=\"icon-edit_变更\" class=\"cls-1\" width=\"32\" height=\"32\" rx=\"16\" ry=\"16\" />\r\n  <path id=\"icon-edit_形状_1\" data-name=\"形状 1\" class=\"cls-2\" d=\"M677.071,337.279v3.184h3.269l8.5-8.912-3.268-3.182Zm14.382-8.272a0.956,0.956,0,0,0,0-1.274l-1.961-1.91a1.027,1.027,0,0,0-1.307,0l-1.962,1.91,3.269,3.182,1.961-1.909h0Zm-7.844,10.181-1.308,1.275h9.822a0.638,0.638,0,1,0,0-1.275h-8.514Zm0,0\" transform=\"translate(-669 -317)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/edit.svg
// module id = ql+d
// module chunks = 127